import React, { FC } from 'react';
import GalleryHeaderContainer from '../GalleryHeader/GalleryHeaderContainer';
import s from './GalleryGrid.module.scss';

export type GalleryGridProps = {
  header?: React.ReactNode;
  content?: React.ReactNode;
  listClassName?: string;
  listGridClassOverride?: string;
  noTopMargin?: boolean;
};
const GalleryGrid: FC<GalleryGridProps> = ({
  content,
  header,
  listGridClassOverride,
  listClassName,
  noTopMargin,
}) => {
  const listGridClass = listGridClassOverride
    ? listGridClassOverride
    : s.content;

  return (
    <div className={s.gridContainer}>
      <GalleryHeaderContainer className={s.header}>
        {header}
      </GalleryHeaderContainer>
      <ul
        className={`${listGridClass} ${listClassName} ${
          noTopMargin ? s.noTopMargin : ''
        }`}
      >
        {content}
      </ul>
    </div>
  );
};

export default GalleryGrid;
